export default __webpack_public_path__ + "static/media/encontre.83677ec5.jpeg";